import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d2743c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid grid-header-title w-full -ml-2 -mr-2" }
const _hoisted_2 = { class: "col-6" }
const _hoisted_3 = { class: "mt-2 mr-2 ml-0 mb-0 font-normal" }

import { withDefaults, computed } from "vue";
import { EventClickArg, EventInput } from "@fullcalendar/core";

type IHeaderNewSidebar = {
  bookingId: string | undefined;
  eventArg?:
    | EventClickArg
    | EventInput
    | {
        resource?: {
          id?: string;
          _context?: any;
        };
      };
  bookingType?: string;
  bookingStatus?: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'header',
  props: {
    bookingId: { default: "" },
    eventArg: { default: undefined },
    bookingType: { default: "" },
    bookingStatus: { default: "" }
  },
  setup(__props: any) {

const props = __props as { bookingId: string | undefined, eventArg:
    | EventClickArg
    | EventInput
    | {
        resource?: {
          id?: string;
          _context?: any;
        };
      }, bookingType: string, bookingStatus: string };



// リソースIDが"fs"で終わる場合はフリースペース
const isFreeSpace = computed(() => {
  // eventArgからリソースIDを取得
  const resourceId = props.eventArg?.resource?.id;

  // リソースIDが"fs"で終わる場合はフリースペース
  if (resourceId && typeof resourceId === "string") {
    return resourceId.endsWith("fs");
  }

  return false;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_unref(isFreeSpace) ? "新規自由予約" : "新規予約"), 1)
    ])
  ]))
}
}

})